let scrollItems = document.querySelectorAll('.animateIn');
let options = {
  rootMargin: '-10%',
  threshold: 0.0
}

let textItems = document.querySelectorAll('h2');

let observer = new IntersectionObserver(showItem, options);

function showItem(entries){
  entries.forEach( entry => {
    console.log(entry)
    if(entry.isIntersecting){
      console.log("is intersecting")
      let letters = [...entry.target.querySelectorAll('span')];
      letters.forEach((letter, idx) => {
        setTimeout(() =>{
          letter.classList.add('active');
        }, idx * 70)
      })
      entry.target.classList.add('active');
    }
    else {
      entry.target.classList.remove('active');

    }
  })
}
 
scrollItems.forEach(scrollItem => {
  observer.observe(scrollItem);

})

// textItems.forEach(item => {
//   let newString = '';
//   let itemText = item.innerText.split('');
//   itemText.map(letter => (newString += letter == ' ' ? `<span class='gap'></span>` : `<span>${letter}</span>`))
//   item.innerHTML = newString;
//   observer.observe(item);
// })
